
import FontCommand from '@ckeditor/ckeditor5-font/src/fontcommand';

export default class FontColorCommand extends FontCommand {

	constructor( editor ) {
		super( editor, 'fontColor' );
	}
}
